var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2 2H1.8C0.81 2 0.00899999 2.84375 0.00899999 3.875L0 15.125C0 16.1562 0.81 17 1.8 17H16.2C17.19 17 18 16.1562 18 15.125V3.875C18 2.84375 17.19 2 16.2 2ZM15.84 5.98438L9.477 10.1281C9.189 10.3156 8.811 10.3156 8.523 10.1281L2.16 5.98438C2.06975 5.9316 1.99073 5.86031 1.9277 5.7748C1.86467 5.68929 1.81896 5.59135 1.79332 5.48691C1.76768 5.38247 1.76265 5.27369 1.77854 5.16716C1.79443 5.06064 1.8309 4.95858 1.88575 4.86716C1.9406 4.77574 2.01269 4.69686 2.09765 4.63531C2.18262 4.57375 2.27868 4.53079 2.38005 4.50903C2.48141 4.48727 2.58595 4.48716 2.68736 4.5087C2.78876 4.53025 2.88492 4.573 2.97 4.63437L9 8.5625L15.03 4.63437C15.1151 4.573 15.2112 4.53025 15.3126 4.5087C15.414 4.48716 15.5186 4.48727 15.62 4.50903C15.7213 4.53079 15.8174 4.57375 15.9023 4.63531C15.9873 4.69686 16.0594 4.77574 16.1142 4.86716C16.1691 4.95858 16.2056 5.06064 16.2215 5.16716C16.2373 5.27369 16.2323 5.38247 16.2067 5.48691C16.181 5.59135 16.1353 5.68929 16.0723 5.7748C16.0093 5.86031 15.9302 5.9316 15.84 5.98438Z",
    fill: "#F90182"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundEmail);
export default __webpack_public_path__ + "static/media/ic_round-email.9699b05552310d1ff8914894aa9aa063.svg";
export { ForwardRef as ReactComponent };